function toggleSidebarSection(event) {
    if(dragging) return;

    var target = event.target.closest("aside a.header");
    if(target) {
        event.preventDefault();
        event.stopPropagation();

        target.classList.toggle("content-shown");
        target.nextElementSibling.classList.toggle("is-shown");
    }
}

document.addEventListener("click", toggleSidebarSection);
document.addEventListener("touchend", toggleSidebarSection);